<div mat-dialog-title>
  <h2>{{ data.title }}</h2>

  <button
    [mat-dialog-close]="false"
    matIconButton
    class="close-btn"
    aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p class="text">
    Please review and accept the additional terms and conditions to subscribe to this service.
    Access will be activated shortly after confirmation, and ume will contact you with further
    details.
  </p>
  @if (terms.length) {
    <ume-offering-terms-and-conditions-list
      [terms]="terms"></ume-offering-terms-and-conditions-list>
  }
  <mat-checkbox [(ngModel)]="agreeTerms">
    I have read and accepted the additional terms and conditions.
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    matButton
    [mat-dialog-close]="false">
    Cancel
  </button>
  <button
    matButton="filled"
    class="primary-button"
    [disabled]="!agreeTerms"
    [mat-dialog-close]="true">
    Confirm
  </button>
</mat-dialog-actions>
